import {factor, pixels} from '../../abstract-units';

export const EDGE_AREA_THICKNESS_PX = 4; // Half of edge thickness.

export const ZERO_POS  = pixels(0);
export const CELL_SIZE = factor(1);
